import assign from 'lodash/assign';

// Constellation
import { Box, Checkbox, Label, LabeledControl } from '@zillow/constellation-10';

// Components
import FilterWrapper from '../FilterWrapper';

// Flux
import { useAppSelector } from '../../flux/configureStore';

// Misc / Utils
import { useOptimisticReducer } from '../../utils/hooks';

// Types
import type { PartialFilterType, propertyTypesType } from '../../models/Types';

const PropertyType = ({ onFilterChange }: { onFilterChange: (arg0: PartialFilterType) => void }) => {
  const propertyTypeFilterRedux = useAppSelector((state) => state.filter.propertyTypes);
  const [propertyTypeFilter, setPropertyTypeFilter] = useOptimisticReducer(propertyTypeFilterRedux);
  const { apartment, condo, house, townhouse } = propertyTypeFilter;

  const handleFilterClick = (propertyType: keyof propertyTypesType) => {
    setPropertyTypeFilter({ type: propertyType, payload: !propertyTypeFilter[propertyType] });
    const newPropertyTypeFilter = assign({}, propertyTypeFilter);
    newPropertyTypeFilter[propertyType] = !propertyTypeFilter[propertyType];
    onFilterChange({ propertyTypes: newPropertyTypeFilter });
  };

  const component = (
    <Box css={{ width: '100%', paddingBlock: '200' }}>
      <Box css={{ minWidth: '320px', padding: '{spacing.100} {spacing.600}' }}>
        <LabeledControl
          controlId="homeType-houses"
          label={<Label>Houses</Label>}
          control={<Checkbox checked={house} onChange={() => handleFilterClick('house')} />}
        />
      </Box>
      <Box css={{ minWidth: '320px', padding: '{spacing.100} {spacing.600}' }}>
        <LabeledControl
          controlId="homeType-condos"
          label={<Label>Condos/Co-ops</Label>}
          control={<Checkbox checked={condo} onChange={() => handleFilterClick('condo')} />}
        />
      </Box>
      <Box css={{ minWidth: '320px', padding: '{spacing.100} {spacing.600}' }}>
        <LabeledControl
          controlId="homeType-apartments"
          label={<Label>Apartments</Label>}
          control={<Checkbox checked={apartment} onChange={() => handleFilterClick('apartment')} />}
        />
      </Box>
      <Box css={{ minWidth: '320px', padding: '{spacing.100} {spacing.600}' }}>
        <LabeledControl
          controlId="homeType-townhomes"
          label={<Label>Townhomes</Label>}
          control={<Checkbox checked={townhouse} onChange={() => handleFilterClick('townhouse')} />}
        />
      </Box>
    </Box>
  );

  return FilterWrapper({
    heading: 'Property Type',
    children: component,
  });
};

export default PropertyType;
